var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bgImg" }, [
    _c("img", {
      staticClass: "loginLogo",
      attrs: { src: _vm.EnvUrl + _vm.logo, alt: "" }
    }),
    _vm._v(" "),
    _vm.forgetStatus === 1
      ? _c("div", { staticClass: "contentBox" }, [
          _c("div", { staticClass: "inputBox" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.studentNo,
                  expression: "studentNo"
                }
              ],
              attrs: {
                type: "text",
                autocomplete: "off",
                placeholder: _vm.placeholder1
              },
              domProps: { value: _vm.studentNo },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.studentNo = $event.target.value
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "inputBox" }, [
            _vm.type === "checkbox"
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.studentCard,
                      expression: "studentCard"
                    }
                  ],
                  attrs: {
                    autocomplete: "new-password",
                    placeholder: _vm.placeholder2,
                    type: "checkbox"
                  },
                  domProps: {
                    checked: Array.isArray(_vm.studentCard)
                      ? _vm._i(_vm.studentCard, null) > -1
                      : _vm.studentCard
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.studentCard,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.studentCard = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.studentCard = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.studentCard = $$c
                      }
                    }
                  }
                })
              : _vm.type === "radio"
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.studentCard,
                        expression: "studentCard"
                      }
                    ],
                    attrs: {
                      autocomplete: "new-password",
                      placeholder: _vm.placeholder2,
                      type: "radio"
                    },
                    domProps: { checked: _vm._q(_vm.studentCard, null) },
                    on: {
                      change: function($event) {
                        _vm.studentCard = null
                      }
                    }
                  })
                : _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.studentCard,
                        expression: "studentCard"
                      }
                    ],
                    attrs: {
                      autocomplete: "new-password",
                      placeholder: _vm.placeholder2,
                      type: _vm.type
                    },
                    domProps: { value: _vm.studentCard },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.studentCard = $event.target.value
                      }
                    }
                  }),
            _vm._v(" "),
            _c("div", {
              staticClass: "iconEye",
              class: { active: _vm.type === "text" },
              on: { click: _vm.show }
            })
          ]),
          _vm._v(" "),
          _vm.showForgetBox
            ? _c("div", { staticClass: "forgetBox" }, [
                _c(
                  "span",
                  {
                    on: {
                      click: function($event) {
                        _vm.forget(2)
                      }
                    }
                  },
                  [_vm._v("忘记密码？")]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "loginBtn",
              class: { active: _vm.studentNo && _vm.studentCard },
              on: { click: _vm.login }
            },
            [_vm._v("登 录")]
          ),
          _vm._v(" "),
          _vm.showForgetBox
            ? _c(
                "div",
                {
                  staticClass: "forget",
                  on: {
                    click: function($event) {
                      _vm.forget(3)
                    }
                  }
                },
                [_vm._v("注 册")]
              )
            : _vm._e()
        ])
      : _vm.forgetStatus === 2
        ? _c("div", [
            _c("div", { staticClass: "inputBox" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.userPhone,
                    expression: "userPhone"
                  }
                ],
                attrs: {
                  type: "text",
                  autocomplete: "off",
                  placeholder: "请输入手机号"
                },
                domProps: { value: _vm.userPhone },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.userPhone = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "inputBox codeBox" }, [
              _c("div", { staticClass: "codeLeft" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.code,
                      expression: "code"
                    }
                  ],
                  staticStyle: { width: "2.2rem" },
                  attrs: {
                    autocomplete: "new-password",
                    placeholder: "请输入验证码"
                  },
                  domProps: { value: _vm.code },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.code = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _vm.status === 0
                ? _c(
                    "div",
                    {
                      staticClass: "getCode",
                      on: { click: _vm.getSmsAuthCode }
                    },
                    [_vm._v("获取验证码")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.status === 1
                ? _c("div", { staticClass: "getCode" }, [
                    _vm._v("重新获取(" + _vm._s(_vm.num) + ")")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.status === 2
                ? _c(
                    "div",
                    {
                      staticClass: "getCode",
                      on: { click: _vm.getSmsAuthCode }
                    },
                    [_vm._v("重新获取")]
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "inputBox" }, [
              _vm.type === "checkbox"
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.userPsw,
                        expression: "userPsw"
                      }
                    ],
                    attrs: {
                      autocomplete: "new-password",
                      placeholder: "请重置密码",
                      type: "checkbox"
                    },
                    domProps: {
                      checked: Array.isArray(_vm.userPsw)
                        ? _vm._i(_vm.userPsw, null) > -1
                        : _vm.userPsw
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.userPsw,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.userPsw = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.userPsw = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.userPsw = $$c
                        }
                      }
                    }
                  })
                : _vm.type === "radio"
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.userPsw,
                          expression: "userPsw"
                        }
                      ],
                      attrs: {
                        autocomplete: "new-password",
                        placeholder: "请重置密码",
                        type: "radio"
                      },
                      domProps: { checked: _vm._q(_vm.userPsw, null) },
                      on: {
                        change: function($event) {
                          _vm.userPsw = null
                        }
                      }
                    })
                  : _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.userPsw,
                          expression: "userPsw"
                        }
                      ],
                      attrs: {
                        autocomplete: "new-password",
                        placeholder: "请重置密码",
                        type: _vm.type
                      },
                      domProps: { value: _vm.userPsw },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.userPsw = $event.target.value
                        }
                      }
                    }),
              _vm._v(" "),
              _c("div", {
                staticClass: "iconEye",
                class: { active: _vm.type === "text" },
                on: { click: _vm.show }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "forgetBox",
                on: {
                  click: function($event) {
                    _vm.forget(1)
                  }
                }
              },
              [_vm._v("返回登录")]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "loginBtn", on: { click: _vm.changeDoctorPsw } },
              [_vm._v("重置密码")]
            )
          ])
        : _c("div", [
            _c("div", { staticClass: "inputBox" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.userPhone,
                    expression: "userPhone"
                  }
                ],
                attrs: {
                  type: "text",
                  autocomplete: "off",
                  placeholder: "请输入手机号"
                },
                domProps: { value: _vm.userPhone },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.userPhone = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "inputBox codeBox" }, [
              _c("div", { staticClass: "codeLeft" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.code,
                      expression: "code"
                    }
                  ],
                  staticStyle: { width: "2.2rem" },
                  attrs: {
                    autocomplete: "new-password",
                    placeholder: "请输入验证码"
                  },
                  domProps: { value: _vm.code },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.code = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _vm.status === 0
                ? _c(
                    "div",
                    {
                      staticClass: "getCode",
                      on: { click: _vm.getSmsAuthCode }
                    },
                    [_vm._v("获取验证码")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.status === 1
                ? _c("div", { staticClass: "getCode" }, [
                    _vm._v("重新获取(" + _vm._s(_vm.num) + ")")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.status === 2
                ? _c(
                    "div",
                    {
                      staticClass: "getCode",
                      on: { click: _vm.getSmsAuthCode }
                    },
                    [_vm._v("重新获取")]
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "inputBox" }, [
              _vm.type === "checkbox"
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.userPsw,
                        expression: "userPsw"
                      }
                    ],
                    attrs: {
                      autocomplete: "new-password",
                      placeholder: "请设置密码",
                      type: "checkbox"
                    },
                    domProps: {
                      checked: Array.isArray(_vm.userPsw)
                        ? _vm._i(_vm.userPsw, null) > -1
                        : _vm.userPsw
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.userPsw,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.userPsw = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.userPsw = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.userPsw = $$c
                        }
                      }
                    }
                  })
                : _vm.type === "radio"
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.userPsw,
                          expression: "userPsw"
                        }
                      ],
                      attrs: {
                        autocomplete: "new-password",
                        placeholder: "请设置密码",
                        type: "radio"
                      },
                      domProps: { checked: _vm._q(_vm.userPsw, null) },
                      on: {
                        change: function($event) {
                          _vm.userPsw = null
                        }
                      }
                    })
                  : _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.userPsw,
                          expression: "userPsw"
                        }
                      ],
                      attrs: {
                        autocomplete: "new-password",
                        placeholder: "请设置密码",
                        type: _vm.type
                      },
                      domProps: { value: _vm.userPsw },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.userPsw = $event.target.value
                        }
                      }
                    }),
              _vm._v(" "),
              _c("div", {
                staticClass: "iconEye",
                class: { active: _vm.type === "text" },
                on: { click: _vm.show }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "forgetBox",
                on: {
                  click: function($event) {
                    _vm.forget(1)
                  }
                }
              },
              [_vm._v("返回登录")]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "loginBtn", on: { click: _vm.doScaleUserLogin } },
              [_vm._v("注册")]
            )
          ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10d9df09", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10d9df09","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/login.vue
// module id = null
// module chunks = 